// src/app/modules/Dashboard/config/organizationTypes.js
// 🎯 Smart configuration for different organization types

export const ORGANIZATION_TYPES = {
  residential_estate: {
    name: 'Residential Estate',
    features: {
      hasStaff: false,
      hasResidents: true,
      hasVisitors: true,
      hasUnits: true,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: true,
    },
    labels: {
      // Sidebar labels
      dashboard: 'Dashboard',
      accessControl: 'Gate Control',
      incidents: 'Security Incidents',
      threatAlerts: 'Security Alerts',
      blacklist: 'Blacklist',
      members: 'Residents',
      visitors: 'Visitors & Guests',
      spaces: 'Houses & Units',
      space_unit: 'house',
      reports: 'Reports',
      settings: 'Estate Settings',
      memberName: 'Member',
      
      // Dashboard labels
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Current Visitors',
      staff: 'Security Staff',
      residents: 'Residents',
      units: 'Houses/Units',
      
      // Access control
      checkIn: 'Gate Entry',
      checkOut: 'Gate Exit',
      vehicleEntry: 'Vehicle Entry',

      membersTitle: 'Residents',
      organizationMembers: 'Residents, admins and security',
      
      // Unified dashboard
      currentlyInside: 'Currently Inside Estate',
      todayEntries: "Today's Entries",
    },
    modules: {
      // Which modules to show
      showStaffModule: true,
      showResidentModule: true,
      showVehicleTracking: true,
      showUnitManagement: true,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      // Sidebar customization
      groupStaffAndResidents: true, // Combine under "Residents & Staff"
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Houses & Units',
    }
  },

  commercial_building: {
    name: 'Commercial Building',
    features: {
      hasStaff: true,
      hasResidents: false,
      hasVisitors: true,
      hasUnits: true,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Access Control',
      incidents: 'Incidents',
      threatAlerts: 'Threat Alerts',
      blacklist: 'Blacklist',
      members: 'Tenants & Staff',
      visitors: 'Visitors',
      spaces: 'Offices & Suites',
      space_unit: 'office',
      reports: 'Reports',
      settings: 'Building Settings',
      memberName: 'Member',

      membersTitle: 'Tenants & Staff',
      organizationMembers: 'Tenants, Staffs, admins and security',
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Active Visitors',
      staff: 'Staff',
      residents: 'Tenants',
      units: 'Office Spaces',
      
      checkIn: 'Check-In',
      checkOut: 'Check-Out',
      vehicleEntry: 'Parking Entry',
      
      currentlyInside: 'Currently in Building',
      todayEntries: "Today's Check-Ins",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: false, // No residents, use "Tenants"
      showVehicleTracking: true,
      showUnitManagement: true,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Offices',
    }
  },


  office_building: {
    name: 'Office Building',
    features: {
      hasStaff: true,
      hasResidents: false,
      hasVisitors: true,
      hasUnits: true,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Access Control',
      incidents: 'Incidents',
      threatAlerts: 'Threat Alerts',
      blacklist: 'Blacklist',
      members: 'Staff',
      visitors: 'Visitors',
      spaces: 'Departments',
      space_unit: 'department',
      reports: 'Reports',
      settings: 'Office Settings',
      memberName: 'Team Member',

      membersTitle: 'Staffs',
      organizationMembers: 'Staffs, admins and security',
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Active Visitors',
      staff: 'Staff',
      residents: 'Staffs',
      units: 'Office Department',
      
      checkIn: 'Check-In',
      checkOut: 'Check-Out',
      vehicleEntry: 'Parking Entry',
      
      currentlyInside: 'Currently in Building',
      todayEntries: "Today's Check-Ins",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: false, // No residents, use "Tenants"
      showVehicleTracking: true,
      showUnitManagement: true,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Offices',
    }
  },

  residential_building: {
    name: 'Residential Building',
    features: {
      hasStaff: true,
      hasResidents: true,
      hasVisitors: true,
      hasUnits: true,
      hasSpaces: true,
      hasVehicleTracking: false,
      hasFamilyMembers: true,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Building Access',
      incidents: 'Incidents',
      threatAlerts: 'Alerts',
      blacklist: 'Blacklist',
      members: 'Residents',
      visitors: 'Visitors',
      space_unit: 'house',
      spaces: 'Apartments',
      reports: 'Reports',
      settings: 'Building Settings',
      memberName: 'Resident',

      membersTitle: 'Residents',
      organizationMembers: 'Residents, admins and security',
      
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Current Visitors',
      staff: 'Staff',
      residents: 'Residents',
      units: 'Apartments',
      
      checkIn: 'Building Entry',
      checkOut: 'Building Exit',
      
      currentlyInside: 'Currently in Building',
      todayEntries: "Today's Entries",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: true,
      showVehicleTracking: false,
      showUnitManagement: true,
      showGateControl: false,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: true,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Apartments',
    }
  },

  event_venue: {
    name: 'Event Venue',
    features: {
      hasStaff: true,
      hasResidents: false,
      hasVisitors: true,
      hasUnits: false,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Event Access',
      incidents: 'Incidents',
      threatAlerts: 'Security Alerts',
      blacklist: 'Blacklist',
      members: 'Staff & Vendors',
      visitors: 'Attendees',
      space_unit: 'unit',
      spaces: 'Event Spaces',
      reports: 'Reports',
      settings: 'Venue Settings',
      memberName: 'Member',

      membersTitle: 'Staff & Vendors',
      organizationMembers: 'Vendors, Staffs, admins and security',
      
      
      totalVisitors: 'Total Attendees',
      activeVisitors: 'Current Attendees',
      staff: 'Event Staff',
      residents: 'Vendors',
      units: 'Spaces',
      
      checkIn: 'Event Check-In',
      checkOut: 'Event Check-Out',
      vehicleEntry: 'Parking Entry',
      
      currentlyInside: 'Currently at Venue',
      todayEntries: "Today's Attendees",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: false,
      showVehicleTracking: true,
      showUnitManagement: false,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: false,
      showSpaces: true,
      spaceLabel: 'Event Spaces',
    }
  },

  retail: {
    name: 'Retail',
    features: {
      hasStaff: true,
      hasResidents: false,
      hasVisitors: true,
      hasUnits: false,
      hasSpaces: false,
      hasVehicleTracking: false,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Store Access',
      incidents: 'Incidents',
      threatAlerts: 'Security Alerts',
      blacklist: 'Blacklist',
      members: 'Staff',
      visitors: 'Customers',
      spaces: 'Locations',
      space_unit: 'office',
      reports: 'Reports',
      settings: 'Store Settings',
      memberName: 'Member',
      
      totalVisitors: 'Total Customers',
      activeVisitors: 'Current Customers',
      staff: 'Store Staff',
      

        membersTitle: 'Staff',
      organizationMembers: 'Staffs, admins and security',
      
   
      checkIn: 'Clock In',
      checkOut: 'Clock Out',
      
      currentlyInside: 'Currently in Store',
      todayEntries: "Today's Customers",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: false,
      showVehicleTracking: false,
      showUnitManagement: false,
      showGateControl: false,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: false,
      showSpaces: false,
      spaceLabel: 'Stores',
    }
  },

  educational: {
    name: 'Educational',
    features: {
      hasStaff: true,
      hasResidents: false,
      hasVisitors: true,
      hasUnits: false,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Campus Access',
      incidents: 'Incidents',
      threatAlerts: 'Security Alerts',
      blacklist: 'Blacklist',
      members: 'Faculty & Staff',
      visitors: 'Visitors',
      spaces: 'Buildings & Rooms',
      space_unit: 'department',
      reports: 'Reports',
      settings: 'Campus Settings',
      memberName: 'Member',
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Current Visitors',
      staff: 'Faculty & Staff',
      
      checkIn: 'Campus Entry',
      checkOut: 'Campus Exit',
      vehicleEntry: 'Vehicle Entry',
      
      currentlyInside: 'Currently on Campus',
      todayEntries: "Today's Entries",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: false,
      showVehicleTracking: true,
      showUnitManagement: false,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Buildings',
    }
  },

  // Add defaults for other types
  healthcare: {
    name: 'Healthcare',
    features: {
      hasStaff: true,
      hasResidents: false,
      hasVisitors: true,
      hasUnits: false,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Facility Access',
      incidents: 'Incidents',
      threatAlerts: 'Security Alerts',
      blacklist: 'Blacklist',
      members: 'Medical Staff',
      visitors: 'Visitors & Patients',
      spaces: 'Departments',
      space_unit: 'department',
      reports: 'Reports',
      settings: 'Facility Settings',
      memberName: 'Member',
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Current Visitors',
      staff: 'Medical Staff',
      
      checkIn: 'Entry',
      checkOut: 'Exit',
      
      currentlyInside: 'Currently in Facility',
      todayEntries: "Today's Entries",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: false,
      showVehicleTracking: true,
      showUnitManagement: false,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Departments',
    }
  },

  hospitality: {
    name: 'Hospitality',
    features: {
      hasStaff: true,
      hasResidents: true, // Guests
      hasVisitors: true,
      hasUnits: true, // Rooms
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: false,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Property Access',
      incidents: 'Incidents',
      threatAlerts: 'Security Alerts',
      blacklist: 'Blacklist',
      members: 'Staff',
      visitors: 'Guests & Visitors',
      spaces: 'Rooms & Suites',
      space_unit: 'room',
      memberName: 'Member',
      
      reports: 'Reports',
      settings: 'Property Settings',
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Current Guests',
      staff: 'Hotel Staff',
      residents: 'Checked-In Guests',
      units: 'Rooms',
      
      checkIn: 'Check-In',
      checkOut: 'Check-Out',
      
      currentlyInside: 'Currently on Property',
      todayEntries: "Today's Check-Ins",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: true,
      showVehicleTracking: true,
      showUnitManagement: true,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Rooms',
    }
  },

  event_organizer: {
    name: 'Event Organizer',
    features: {
      hasStaff: false,
      hasResidents: false,
      hasVisitors: false,
      hasUnits: false,
      hasSpaces: false,
      hasVehicleTracking: false,
      hasFamilyMembers: false,
      hasTicketing: true,
    },
    labels: {
      dashboard: 'Overview',
      events: 'Events',
      tickets: 'Tickets & Orders',
      wallet: 'Wallet',
      settings: 'Settings',
      memberName: 'Team Member',
      membersTitle: 'Team',
      organizationMembers: 'Admins and team members',
      totalEvents: 'Total Events',
      activeEvents: 'Active Events',
      ticketsSold: 'Tickets Sold',
      revenue: 'Revenue',
    },
    modules: {
      showStaffModule: false,
      showResidentModule: false,
      showVehicleTracking: false,
      showUnitManagement: false,
      showGateControl: false,
      showSecurityIncidents: false,
      showTicketing: true,
    },
    sidebar: {
      groupStaffAndResidents: false,
      showIntelligence: false,
      showSpaces: false,
      spaceLabel: '',
      isEventOrganizer: true,
    },
  },

  // Default fallback
  default: {
    name: 'Organization',
    features: {
      hasStaff: true,
      hasResidents: true,
      hasVisitors: true,
      hasUnits: true,
      hasSpaces: true,
      hasVehicleTracking: true,
      hasFamilyMembers: true,
    },
    labels: {
      dashboard: 'Dashboard',
      accessControl: 'Access Control',
      incidents: 'Incidents',
      threatAlerts: 'Threat Alerts',
      blacklist: 'Blacklist',
      members: 'Members',
      visitors: 'Visitors',
      spaces: 'Spaces',
      space_unit: 'unit',
      reports: 'Reports',
      settings: 'Settings',
      memberName: 'Member',
      
      totalVisitors: 'Total Visitors',
      activeVisitors: 'Active Visitors',
      staff: 'Staff',
      residents: 'Residents',
      units: 'Units',
      
      checkIn: 'Check-In',
      checkOut: 'Check-Out',
      
      currentlyInside: 'Currently Inside',
      todayEntries: "Today's Entries",
    },
    modules: {
      showStaffModule: true,
      showResidentModule: true,
      showVehicleTracking: true,
      showUnitManagement: true,
      showGateControl: true,
      showSecurityIncidents: true,
    },
    sidebar: {
      groupStaffAndResidents: true,
      showIntelligence: true,
      showSpaces: true,
      spaceLabel: 'Spaces',
    }
  },
};

/**
 * Get configuration for organization type
 * @param {string} orgType - Organization type
 * @returns {Object} Configuration object
 */
export function getOrgConfig(orgType) {
  return ORGANIZATION_TYPES[orgType] || ORGANIZATION_TYPES.default;
}

/**
 * Get label for organization type
 * @param {string} orgType - Organization type
 * @param {string} labelKey - Label key to get
 * @returns {string} Label text
 */
export function getOrgLabel(orgType, labelKey) {
  const config = getOrgConfig(orgType);
  return config.labels[labelKey] || labelKey;
}

/**
 * Check if feature is enabled for organization type
 * @param {string} orgType - Organization type
 * @param {string} featureKey - Feature key to check
 * @returns {boolean} Whether feature is enabled
 */
export function hasOrgFeature(orgType, featureKey) {
  const config = getOrgConfig(orgType);
  return config.features[featureKey] || false;
}

/**
 * Check if module should be shown for organization type
 * @param {string} orgType - Organization type
 * @param {string} moduleKey - Module key to check
 * @returns {boolean} Whether module should be shown
 */
export function showOrgModule(orgType, moduleKey) {
  const config = getOrgConfig(orgType);
  return config.modules[moduleKey] || false;
}

/**
 * Get sidebar configuration for organization type
 * @param {string} orgType - Organization type
 * @returns {Object} Sidebar configuration
 */
export function getOrgSidebarConfig(orgType) {
  const config = getOrgConfig(orgType);
  return config.sidebar;
}